import { render } from "./CalendarEventDetailsView.vue?vue&type=template&id=26d0c5dc&scoped=true"
import script from "./CalendarEventDetailsView.vue?vue&type=script&lang=ts"
export * from "./CalendarEventDetailsView.vue?vue&type=script&lang=ts"

import "./CalendarEventDetailsView.vue?vue&type=style&index=0&id=26d0c5dc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-26d0c5dc"

export default script